{
    "v": "4.8.0",
    "meta": { "g": "LottieFiles AE ", "a": "", "k": "", "d": "", "tc": "" },
    "fr": 25,
    "ip": 0,
    "op": 50,
    "w": 500,
    "h": 500,
    "nm": "39 - Stethoscope",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 5,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 24, "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "HIghlight 2",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 32,
                            "s": [100]
                        },
                        { "t": 42, "s": [0] }
                    ],
                    "ix": 11
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [208.651, 130.142, 0], "ix": 2 },
                "a": { "a": 0, "k": [158.651, 80.142, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 27,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -22.224],
                                                    [22.224, 0],
                                                    [0, 22.224],
                                                    [-22.224, 0]
                                                ],
                                                "o": [
                                                    [0, 22.224],
                                                    [-22.224, 0],
                                                    [0, -22.224],
                                                    [22.224, 0]
                                                ],
                                                "v": [
                                                    [197.891, 34.142],
                                                    [157.651, 74.383],
                                                    [117.41, 34.142],
                                                    [157.651, -6.099]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 33,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -30.818],
                                                    [30.818, 0],
                                                    [0, 30.818],
                                                    [-30.818, 0]
                                                ],
                                                "o": [
                                                    [0, 30.818],
                                                    [-30.818, 0],
                                                    [0, -30.818],
                                                    [30.818, 0]
                                                ],
                                                "v": [
                                                    [188.452, 28.742],
                                                    [132.651, 84.543],
                                                    [76.85, 28.742],
                                                    [132.651, -27.059]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 37,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -36.547],
                                                    [36.547, 0],
                                                    [0, 36.547],
                                                    [-36.547, 0]
                                                ],
                                                "o": [
                                                    [0, 36.547],
                                                    [-36.547, 0],
                                                    [0, -36.547],
                                                    [36.547, 0]
                                                ],
                                                "v": [
                                                    [196.159, 30.253],
                                                    [129.984, 96.428],
                                                    [63.809, 30.253],
                                                    [129.984, -35.922]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 42,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -43.709],
                                                    [43.709, 0],
                                                    [0, 43.709],
                                                    [-43.709, 0]
                                                ],
                                                "o": [
                                                    [0, 43.709],
                                                    [-43.709, 0],
                                                    [0, -43.709],
                                                    [43.709, 0]
                                                ],
                                                "v": [
                                                    [223.793, 59.142],
                                                    [144.651, 138.284],
                                                    [65.509, 59.142],
                                                    [144.651, -20]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 23,
            "op": 73,
            "st": 23,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "HIghlight 3",
            "parent": 4,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 9,
                            "s": [100]
                        },
                        { "t": 19, "s": [0] }
                    ],
                    "ix": 11
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [158.651, 80.142, 0], "ix": 2 },
                "a": { "a": 0, "k": [158.651, 80.142, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 4,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -22.224],
                                                    [22.224, 0],
                                                    [0, 22.224],
                                                    [-22.224, 0]
                                                ],
                                                "o": [
                                                    [0, 22.224],
                                                    [-22.224, 0],
                                                    [0, -22.224],
                                                    [22.224, 0]
                                                ],
                                                "v": [
                                                    [198.891, 80.142],
                                                    [158.651, 120.383],
                                                    [118.41, 80.142],
                                                    [158.651, 39.901]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 10,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -30.818],
                                                    [30.818, 0],
                                                    [0, 30.818],
                                                    [-30.818, 0]
                                                ],
                                                "o": [
                                                    [0, 30.818],
                                                    [-30.818, 0],
                                                    [0, -30.818],
                                                    [30.818, 0]
                                                ],
                                                "v": [
                                                    [188.452, 59.742],
                                                    [132.651, 115.543],
                                                    [76.85, 59.742],
                                                    [132.651, 3.941]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 14,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -36.547],
                                                    [36.547, 0],
                                                    [0, 36.547],
                                                    [-36.547, 0]
                                                ],
                                                "o": [
                                                    [0, 36.547],
                                                    [-36.547, 0],
                                                    [0, -36.547],
                                                    [36.547, 0]
                                                ],
                                                "v": [
                                                    [177.381, 42.809],
                                                    [111.206, 108.984],
                                                    [45.031, 42.809],
                                                    [111.206, -23.366]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 19,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -43.709],
                                                    [43.709, 0],
                                                    [0, 43.709],
                                                    [-43.709, 0]
                                                ],
                                                "o": [
                                                    [0, 43.709],
                                                    [-43.709, 0],
                                                    [0, -43.709],
                                                    [43.709, 0]
                                                ],
                                                "v": [
                                                    [188.793, 42.142],
                                                    [109.651, 121.284],
                                                    [30.509, 42.142],
                                                    [109.651, -37]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Stethoscope",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [50, 50, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.51, "y": 0 },
                                        "t": 3,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -14.631],
                                                    [14.631, 0],
                                                    [0, 14.631],
                                                    [-14.631, 0]
                                                ],
                                                "o": [
                                                    [0, 14.631],
                                                    [-14.631, 0],
                                                    [0, -14.631],
                                                    [14.631, 0]
                                                ],
                                                "v": [
                                                    [30.149, -172.622],
                                                    [3.657, -146.131],
                                                    [-22.835, -172.622],
                                                    [3.657, -199.114]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 11,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -14.631],
                                                    [14.631, 0],
                                                    [0, 14.631],
                                                    [-14.631, 0]
                                                ],
                                                "o": [
                                                    [0, 14.631],
                                                    [-14.631, 0],
                                                    [0, -14.631],
                                                    [14.631, 0]
                                                ],
                                                "v": [
                                                    [5.149, -172.622],
                                                    [-21.343, -146.131],
                                                    [-47.835, -172.622],
                                                    [-21.343, -199.114]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.49, "y": 1 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 40,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -14.631],
                                                    [14.631, 0],
                                                    [0, 14.631],
                                                    [-14.631, 0]
                                                ],
                                                "o": [
                                                    [0, 14.631],
                                                    [-14.631, 0],
                                                    [0, -14.631],
                                                    [14.631, 0]
                                                ],
                                                "v": [
                                                    [5.149, -172.622],
                                                    [-21.343, -146.131],
                                                    [-47.835, -172.622],
                                                    [-21.343, -199.114]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 48,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -14.631],
                                                    [14.631, 0],
                                                    [0, 14.631],
                                                    [-14.631, 0]
                                                ],
                                                "o": [
                                                    [0, 14.631],
                                                    [-14.631, 0],
                                                    [0, -14.631],
                                                    [14.631, 0]
                                                ],
                                                "v": [
                                                    [30.149, -172.622],
                                                    [3.657, -146.131],
                                                    [-22.835, -172.622],
                                                    [3.657, -199.114]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.51, "y": 0 },
                                        "t": 3,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -14.631],
                                                    [14.631, 0],
                                                    [0, 14.631],
                                                    [-14.631, 0]
                                                ],
                                                "o": [
                                                    [0, 14.631],
                                                    [-14.631, 0],
                                                    [0, -14.631],
                                                    [14.631, 0]
                                                ],
                                                "v": [
                                                    [-110.391, -172.622],
                                                    [-136.883, -146.131],
                                                    [-163.375, -172.622],
                                                    [-136.883, -199.114]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 11,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -14.631],
                                                    [14.631, 0],
                                                    [0, 14.631],
                                                    [-14.631, 0]
                                                ],
                                                "o": [
                                                    [0, 14.631],
                                                    [-14.631, 0],
                                                    [0, -14.631],
                                                    [14.631, 0]
                                                ],
                                                "v": [
                                                    [-85.391, -172.622],
                                                    [-111.883, -146.131],
                                                    [-138.375, -172.622],
                                                    [-111.883, -199.114]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.49, "y": 1 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 40,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -14.631],
                                                    [14.631, 0],
                                                    [0, 14.631],
                                                    [-14.631, 0]
                                                ],
                                                "o": [
                                                    [0, 14.631],
                                                    [-14.631, 0],
                                                    [0, -14.631],
                                                    [14.631, 0]
                                                ],
                                                "v": [
                                                    [-85.391, -172.622],
                                                    [-111.883, -146.131],
                                                    [-138.375, -172.622],
                                                    [-111.883, -199.114]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 48,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -14.631],
                                                    [14.631, 0],
                                                    [0, 14.631],
                                                    [-14.631, 0]
                                                ],
                                                "o": [
                                                    [0, 14.631],
                                                    [-14.631, 0],
                                                    [0, -14.631],
                                                    [14.631, 0]
                                                ],
                                                "v": [
                                                    [-110.391, -172.622],
                                                    [-136.883, -146.131],
                                                    [-163.375, -172.622],
                                                    [-136.883, -199.114]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.49, "y": 1 },
                                        "o": { "x": 0.51, "y": 0 },
                                        "t": 3,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -22.224],
                                                    [22.224, 0],
                                                    [0, 22.224],
                                                    [-22.224, 0]
                                                ],
                                                "o": [
                                                    [0, 22.224],
                                                    [-22.224, 0],
                                                    [0, -22.224],
                                                    [22.224, 0]
                                                ],
                                                "v": [
                                                    [198.891, 80.142],
                                                    [158.651, 120.383],
                                                    [118.41, 80.142],
                                                    [158.651, 39.901]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.49, "y": 1 },
                                        "o": { "x": 0.51, "y": 0 },
                                        "t": 17,
                                        "s": [
                                            {
                                                "i": [
                                                    [-6.863, -21.138],
                                                    [21.138, -6.863],
                                                    [6.863, 21.138],
                                                    [-21.138, 6.863]
                                                ],
                                                "o": [
                                                    [6.863, 21.138],
                                                    [-21.138, 6.863],
                                                    [-6.863, -21.138],
                                                    [21.138, -6.863]
                                                ],
                                                "v": [
                                                    [145.772, 27.639],
                                                    [119.925, 78.339],
                                                    [69.224, 52.492],
                                                    [95.072, 1.792]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.49, "y": 1 },
                                        "o": { "x": 0.51, "y": 0 },
                                        "t": 24.6,
                                        "s": [
                                            {
                                                "i": [
                                                    [1.869, -22.146],
                                                    [22.146, 1.869],
                                                    [-1.869, 22.146],
                                                    [-22.146, -1.869]
                                                ],
                                                "o": [
                                                    [-1.869, 22.146],
                                                    [-22.146, -1.869],
                                                    [1.869, -22.146],
                                                    [22.146, 1.869]
                                                ],
                                                "v": [
                                                    [199.138, 37.576],
                                                    [155.656, 74.29],
                                                    [118.942, 30.809],
                                                    [162.424, -5.906]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.49, "y": 1 },
                                        "o": { "x": 0.51, "y": 0 },
                                        "t": 35.4,
                                        "s": [
                                            {
                                                "i": [
                                                    [1.869, -22.146],
                                                    [22.146, 1.869],
                                                    [-1.869, 22.146],
                                                    [-22.146, -1.869]
                                                ],
                                                "o": [
                                                    [-1.869, 22.146],
                                                    [-22.146, -1.869],
                                                    [1.869, -22.146],
                                                    [22.146, 1.869]
                                                ],
                                                "v": [
                                                    [168.138, 30.576],
                                                    [124.656, 67.29],
                                                    [87.942, 23.809],
                                                    [131.424, -12.906]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 48,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -22.224],
                                                    [22.224, 0],
                                                    [0, 22.224],
                                                    [-22.224, 0]
                                                ],
                                                "o": [
                                                    [0, 22.224],
                                                    [-22.224, 0],
                                                    [0, -22.224],
                                                    [22.224, 0]
                                                ],
                                                "v": [
                                                    [198.891, 80.142],
                                                    [158.651, 120.383],
                                                    [118.41, 80.142],
                                                    [158.651, 39.901]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.49, "y": 1 },
                                        "o": { "x": 0.51, "y": 0 },
                                        "t": 3,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [-43.467, 0],
                                                    [0, 0],
                                                    [0, 17.656],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 43.467],
                                                    [0, 0],
                                                    [17.656, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-65.237, 44.607],
                                                    [-65.237, 120.383],
                                                    [13.467, 199.087],
                                                    [126.682, 199.087],
                                                    [158.651, 167.119],
                                                    [158.651, 120.382]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.49, "y": 1 },
                                        "o": { "x": 0.51, "y": 0 },
                                        "t": 17,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [-42.533, 1.087],
                                                    [0, 0],
                                                    [-1.142, 30.291],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 43.467],
                                                    [42.533, -1.087],
                                                    [14.676, -7.069],
                                                    [1.142, -30.291],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-65.237, 44.607],
                                                    [-65.237, 120.383],
                                                    [13.467, 199.087],
                                                    [102.824, 175.069],
                                                    [134.358, 129.291],
                                                    [119.925, 78.339]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.49, "y": 1 },
                                        "o": { "x": 0.51, "y": 0 },
                                        "t": 25,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [-42.533, 1.087],
                                                    [0, 0],
                                                    [-6.17, 24.152],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 43.467],
                                                    [42.533, -1.087],
                                                    [21.176, -13.069],
                                                    [5.593, -21.892],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-65.237, 44.607],
                                                    [-65.237, 120.383],
                                                    [13.467, 199.087],
                                                    [102.824, 175.069],
                                                    [151.67, 120.848],
                                                    [155.6, 74.277]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.49, "y": 1 },
                                        "o": { "x": 0.51, "y": 0 },
                                        "t": 35,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [-42.533, 1.087],
                                                    [0, 0],
                                                    [-1.494, 17.606],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 43.467],
                                                    [42.533, -1.087],
                                                    [21.176, -13.069],
                                                    [0.011, -0.043],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-65.237, 44.607],
                                                    [-65.237, 120.383],
                                                    [13.467, 199.087],
                                                    [102.824, 175.069],
                                                    [126.788, 117.875],
                                                    [124.717, 67.304]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 48,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [-43.467, 0],
                                                    [0, 0],
                                                    [0, 17.656],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 43.467],
                                                    [0, 0],
                                                    [17.656, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-65.237, 44.607],
                                                    [-65.237, 120.383],
                                                    [13.467, 199.087],
                                                    [126.682, 199.087],
                                                    [158.651, 167.119],
                                                    [158.651, 120.382]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 4",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.51, "y": 0 },
                                        "t": 3,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [-73.855, 0],
                                                    [0, 0],
                                                    [0, 73.855],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 73.855],
                                                    [0, 0],
                                                    [73.855, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-163.373, -172.622],
                                                    [-198.964, -172.622],
                                                    [-198.964, -89.119],
                                                    [-65.237, 44.607],
                                                    [-65.237, 44.607],
                                                    [68.489, -89.119],
                                                    [68.489, -172.622],
                                                    [30.538, -172.622]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 11,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [-73.855, 0],
                                                    [0, 0],
                                                    [0, 73.855],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 73.855],
                                                    [0, 0],
                                                    [73.855, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-138.373, -172.622],
                                                    [-173.964, -172.622],
                                                    [-173.964, -89.119],
                                                    [-65.237, 44.607],
                                                    [-65.237, 44.607],
                                                    [43.489, -89.119],
                                                    [43.489, -172.622],
                                                    [5.538, -172.622]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.49, "y": 1 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 40,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [-73.855, 0],
                                                    [0, 0],
                                                    [0, 73.855],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 73.855],
                                                    [0, 0],
                                                    [73.855, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-138.373, -172.622],
                                                    [-173.964, -172.622],
                                                    [-173.964, -89.119],
                                                    [-65.237, 44.607],
                                                    [-65.237, 44.607],
                                                    [43.489, -89.119],
                                                    [43.489, -172.622],
                                                    [5.538, -172.622]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 48,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [-73.855, 0],
                                                    [0, 0],
                                                    [0, 73.855],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 73.855],
                                                    [0, 0],
                                                    [73.855, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-163.373, -172.622],
                                                    [-198.964, -172.622],
                                                    [-198.964, -89.119],
                                                    [-65.237, 44.607],
                                                    [-65.237, 44.607],
                                                    [68.489, -89.119],
                                                    [68.489, -172.622],
                                                    [30.538, -172.622]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 5",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
